// モジュール雛形
export default class IHModule {
  
  static extended(core) {
    $(core).on('ready', () => {
      core.initModule();
    })
  }
  
  initModule() {
    console.log('initModule');
  }
  
}


// WEBPACK FOOTER //
// ./map/js/ih/modules/ih.module.js